import { Datagrid, DateField, FunctionField, List, ResourceProps, ShowButton, TextField } from 'react-admin';

const DisputesList = (props: ResourceProps) => {
  return (
    <List {...props}>
      <Datagrid bulkActionButtons={false}>
        <DateField locales="rus" label="Дата открытия спора" source="createdAt" />
        <FunctionField
          label="Статус спора"
          source="deal.status"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          render={(dispute: any) => {
            return dispute?.isResolved ? 'Завершен' : 'Открыт';
          }}
        />
        <TextField source="deal.ad.owner.phone" label="Заказчик" />
        <TextField source="deal.executionRequest.user.phone" label="Исполнитель" emptyText="Нет email" />

        <TextField label="ID Спора" source="id" />
        <ShowButton label="ПРОСМОТР" />
      </Datagrid>
    </List>
  );
};

export default DisputesList;
